import { DAY_KEYS, DEFAULT_CLASS_SCHEDULE_FILTER } from "./classScheduleFilter";

export const SCHEDULE_FILTER_HASH = "schedule-filter";

/** @returns {import("./classScheduleFilter").DEFAULT_CLASS_SCHEDULE_FILTER extends infer T ? T : never} */
export const parseScheduleFilterSearchParams = (searchParams) => {
  const years = searchParams.get("ageYears");
  if (years === null || years === "") {
    return { ...DEFAULT_CLASS_SCHEDULE_FILTER };
  }

  const months = searchParams.get("ageMonths");
  const daysParam = searchParams.get("days");
  const days = daysParam
    ? daysParam.split(",").filter((day) => DAY_KEYS.includes(day))
    : [];

  return {
    ...DEFAULT_CLASS_SCHEDULE_FILTER,
    childAgeYears: Number(years),
    childAgeMonths: months !== null && months !== "" ? Number(months) : 0,
    days,
  };
};

export const buildProgramScheduleUrl = (
  programName,
  filter,
  { scrollToFilter = true, source } = {}
) => {
  const path = `/programs/program-details/${encodeURIComponent(programName)}`;

  if (filter?.childAgeYears === null || filter?.childAgeYears === undefined) {
    return scrollToFilter ? `${path}#${SCHEDULE_FILTER_HASH}` : path;
  }

  const params = new URLSearchParams();
  params.set("ageYears", String(filter.childAgeYears));
  params.set("ageMonths", String(filter.childAgeMonths ?? 0));

  if (Array.isArray(filter.days) && filter.days.length > 0) {
    params.set("days", filter.days.join(","));
  }

  if (source) {
    params.set("source", source);
  }

  const hash = scrollToFilter ? `#${SCHEDULE_FILTER_HASH}` : "";
  return `${path}?${params.toString()}${hash}`;
};
